import React, { useEffect, useState } from 'react';
import { Box, Card, Avatar, Button, Skeleton, Typography } from '@mui/material';
import { UserPlus, Check, X as XIcon, ArrowRight } from 'lucide-react';
import { useAuth } from "../../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const ConnectionRequests = () => {
  const { user } = useAuth();
  const [requests, setRequests] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const userId = user?.user_id || user?.id;
    if (!userId) {
      setLoading(false);
      return;
    }
    fetch('https://apiweb.hitpoly.com/ajax/communityWidgetsController.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'getConnectionRequests', user_id: userId })
    })
      .then(r => r.json())
      .then(data => {
        if (data && data.success && data.data && data.data.length > 0) {
          setRequests(data.data);
        } else {
          setRequests([]); 
        }
        setLoading(false);
      })
      .catch((error) => {
        setRequests([
          { id: 1, name: 'Juan Pérez', avatar: '/images/default-avatar.png', role: 'Diseñador Gráfico' },
          { id: 2, name: 'María Gómez', avatar: '/images/default-avatar.png', role: 'Marketing Manager' }
        ]);
        setLoading(false);
      });
  }, [user]);

  if (loading) return <Skeleton variant="rectangular" height={150} sx={{ mb: 2, borderRadius: 4 }} />;
  if (!requests || requests.length === 0) return null;

  return (
    <Card sx={{ 
      mb: 3, 
      bgcolor: "rgba(255,255,255,0.9)", 
      backdropFilter: "blur(8px)", 
      borderRadius: 4, 
      border: '1px solid #f0f0f0',
      boxShadow: 'none',
      p: 2.5
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="subtitle1" fontWeight="800" sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#1a1a1a' }}>
          <UserPlus size={18} color="#0a66c2" /> Solicitudes de red
        </Typography>
        <Box sx={{ bgcolor: '#eef3f8', color: '#0a66c2', fontSize: '0.75rem', fontWeight: 'bold', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' }}>
          {requests.length}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {requests.map(req => (
          <Box key={req.id} sx={{ display: 'flex', alignItems: 'center', p: 1.5, borderRadius: 3, border: '1px solid #f5f5f5', bgcolor: '#fafafa' }}>
            <Avatar src={req.avatar || '/images/default-avatar.png'} sx={{ width: 40, height: 40, mr: 1.5 }} />
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="body2" fontWeight="800" color="#1a1a1a" sx={{ lineHeight: 1.1 }}>
                {req.name} {req.apellido}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {req.role || 'Usuario de Hitpoly'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Button variant="contained" size="small" sx={{ minWidth: 32, p: 0.5, borderRadius: 2, boxShadow: 'none' }}>
                <Check size={16} />
              </Button>
              <Button variant="outlined" color="inherit" size="small" sx={{ minWidth: 32, p: 0.5, borderRadius: 2, color: 'text.secondary', borderColor: '#e0e0e0' }}>
                <XIcon size={16} />
              </Button>
            </Box>
          </Box>
        ))}
      </Box>

      <Button 
        onClick={() => navigate('/systems/comunidad/red')}
        sx={{ 
          width: '100%', 
          mt: 1.5, 
          textTransform: 'none', 
          fontWeight: '700',
          color: '#0a66c2',
          '&:hover': { bgcolor: '#eef3f8' }
        }}
        endIcon={<ArrowRight size={16} />}
      >
        Gestionar solicitudes
      </Button>
    </Card>
  );
};

export default ConnectionRequests;
